// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__5Ps2z","log":"ModalInventoryLogs_log__2NPe7","date":"ModalInventoryLogs_date__2BVYE","userName":"ModalInventoryLogs_userName__16DrV"};